import CartActionTypes from "../../actionTypes/cart"
import { getCart } from "../../reducers"
import { getCartItems, updateCart } from "../../../services/cartHelper"

const removeDiscountAction = () => (dispatch, getState) => {

  const {checkout, client, isLoading} = getCart(getState());

  if (isLoading === true) {
    return;
  }

  if (!checkout) {
    console.error('A checkout is required');
    return;
  }

  dispatch({
    type: CartActionTypes.DISCOUNT_REMOVING_ACTION
  });

  const isBrowser = typeof window !== 'undefined';
  let items = [];

  if (isBrowser) {
    items = getCartItems();
  }

  const checkoutId = checkout.id;

  return client.checkout
    .removeDiscount(checkoutId)
    .then(checkout => {
      processCartUpdate(dispatch, items, checkout);
    });
};

function processCartUpdate(dispatch, items, checkout) {
  let cartData = updateCart(items, checkout)

  //create and parse a deep copy of the cartData to avoid mutation
  let newPayload = JSON.parse(JSON.stringify(cartData))

  dispatch({
    type: CartActionTypes.DISCOUNT_REMOVE_ACTION,
    payload: {
      ...newPayload,
      isAdded: true,
    },
  })

  window.setTimeout(function () {
    dispatch({
      type: CartActionTypes.ADDED_ACTION,
      payload: {
        isAdded: false,
      },
    })
  }, 1000)
}

export {
    removeDiscountAction
}
